import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { Tab, Nav, Col, Modal } from 'react-bootstrap';
import Header from './Header';
import Footer from './Footer';
import './Book.css';

function Series() {
    const [book, setBook] = useState(null);
    const [chapters, setChapters] = useState([]);
    const [error, setError] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [selectedChapter, setSelectedChapter] = useState(null);
    const server_base = 'https://bibliotecahumana.urosario.edu.co';
    const { id } = useParams();

    useEffect(() => {
        if (!id) {
            setError('No se ha proporcionado información suficiente para mostrar el libro.');
            return;
        }

        const fetchBook = async () => {
            try {
                const response = await axios.get(`${server_base}/api/libro/${id}`);
                setBook(response.data[0]);
                const chaptersResponse = await axios.get(`${server_base}/api/libro/${id}/capitulos`);
                // Si no hay capítulos, asignar un array vacío
                setChapters(chaptersResponse.data && chaptersResponse.data.length > 0 ? chaptersResponse.data : []);
            } catch (error) {
                console.error(error);
                setError('Error al obtener información del libro');
            }
        };
        fetchBook();
    }, [id]);

    useEffect(() => {
        if (book) {
            document.title = book.title;
            const metaDescription = document.querySelector('meta[name="description"]');
            if (metaDescription) {
                metaDescription.setAttribute("content", book.descripcion);
            }
        }
    }, [book]);

    const handleChapterClick = (e, chapter) => {
        e.preventDefault();
        setSelectedChapter(chapter);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedChapter(null);
    };

    const handleViewFullChapter = () => {
        if (selectedChapter) {
            window.location.href = `${server_base}/libro/${id}/capitulo/${selectedChapter.idObjeto}/view`;
        }
    };

    // Función para crear URL de preview (sin controles, sin autoplay)
    const getPreviewUrl = (url) => {
        if (!url) return '';
        // Agregar parámetros para que se vea como thumbnail estático
        const separator = url.includes('?') ? '&' : '?';
        return `${url}${separator}background=1&muted=1&controls=0&autoplay=0&loop=0`;
    };

    if (!book) {
        return (
            <div>
                <Header />
                <p className="errorMsg">Cargando...</p>
                <Footer />
            </div>
        );
    }

    if (error) {
        return (
            <div>
                <Header />
                <p className="errorMsg">{error}</p>
                <Footer />
            </div>
        );
    }

    const renderAcknowledgements = () => {
        if (!book.agradecimientos) return null;
        const parts = book.agradecimientos.split("/");
        return parts.map((part, idx) => <p key={idx}>{part}</p>);
    };

    const renderCredits = () => {
        if (!book.creditos) return null;
        return book.creditos.split("*").map((section, index) => {
            const content = section.split("$");
            return (
                <div key={index}>
                    {content.map((item, idx) => (
                        <p key={idx} className={idx === 0 ? "seccionT" : "seccion"}>{item}</p>
                    ))}
                </div>
            );
        });
    };

    const renderProductionCredits = () => {
        const credits = [
            { label: 'Producción', value: book.creProduccion },
            { label: 'Diseño tráiler', value: book.creElabTrailer },
            { label: 'Diseño portada', value: book.creElabPortada },
            { label: 'Grabación', value: book.creGrabacion },
            { label: 'Edición', value: book.creEdicion }
        ];

        return (
            <table className="production-credits-table">
                <tbody>
                    {credits.map((credit, index) => {
                        if (!credit.value) return null;
                        const names = credit.value.split(/\s*,\s*/);
                        return (
                            <tr key={index}>
                                <td className="credit-label">{credit.label}:</td>
                                <td className="credit-value">
                                    {names.map((name, idx) => (
                                        <React.Fragment key={idx}>
                                            {name}
                                            {idx < names.length - 1 && <br />}
                                        </React.Fragment>
                                    ))}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        );
    };

    return (
        <>
            <Header />

            <div className="libro">
                <div className="alturaPorDefecto">
                    <div className="miga-pan">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><a href="/">Inicio</a></li>
                                <li className="breadcrumb-item active" aria-current="page" style={{color: "#dee2e6"}}>{book.title}</li>
                            </ol>
                        </nav>
                    </div>

                    {/* Sección Superior - Trailer */}
                    <div className="trailer-section">
                        <div className="trailer-container">
                            <iframe
                                src={book.trailer}
                                width="100%"
                                height="100%"
                                frameBorder="0"
                                scrolling="no"
                                allow="autoplay; fullscreen; picture-in-picture"
                                allowFullScreen
                                title="Trailer Libro">
                            </iframe>
                        </div>
                    </div>

                    {/* Sección Inferior - Capítulos */}
                    <div className="chapters-section">
                        <h2 className="chapters-title">Capítulos:</h2>
                        <div className="chapters-grid">
                            {chapters.map((chapter, index) => (
                                <a
                                    key={index}
                                    href="#"
                                    onClick={(e) => handleChapterClick(e, chapter)}
                                    className="chapter-card"
                                >
                                    {/* Preview del video como portada */}
                                    {chapter.url_capitulo && (
                                        <div className="chapter-thumbnail">
                                            <iframe
                                                src={getPreviewUrl(chapter.url_capitulo)}
                                                width="100%"
                                                height="100%"
                                                frameBorder="0"
                                                title={`Preview ${chapter.title}`}
                                                style={{ pointerEvents: 'none' }}
                                            />
                                            <div className="play-overlay">
                                                <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="32" cy="32" r="32" fill="rgba(145, 116, 179, 0.9)" />
                                                    <path d="M26 20L44 32L26 44V20Z" fill="white" />
                                                </svg>
                                            </div>
                                        </div>
                                    )}
                                    <div className="chapter-card-content">
                                        <div className="chapter-header">
                                            <h3 className="chapter-title">{chapter.title}</h3>
                                            <span className="chapter-duration">{chapter.duracion}</span>
                                        </div>
                                        <p className="chapter-author">{chapter.autor}</p>
                                        {chapter.doi && (
                                            <span className="chapter-doi">{chapter.doi}</span>
                                        )}
                                    </div>
                                </a>
                            ))}

                            {/* Tarjeta de Bibliografía */}
                            {/* COMENTADO TEMPORALMENTE PARA QUE NO SE VEA LA TARJETA DE BIBLIOGRAFIA */}

                            {/* <a
                                href={`${server_base}/libro/${id}/bibliografia`}
                                className="chapter-card bibliography-card"
                            >
                                <div className="chapter-card-content">
                                    <div className="chapter-header">
                                        <h3 className="chapter-title">Bibliografía complementaria</h3>
                                    </div>
                                </div>
                            </a> */}

                        </div>
                    </div>

                    {/* Sección de Agradecimientos y Créditos */}
                    <div className="row mt-5 mb-5">
                        <Col xs={12}>
                            <div className="creditos_agradecimientos">
                                <Tab.Container defaultActiveKey="">
                                    <Nav variant="pills" className="nav-pills-custom">
                                        <Nav.Item>
                                            <Nav.Link eventKey="agradecimientos" className="nav-link-custom">
                                                Agradecimientos
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="creditos" className="nav-link-custom">
                                                Créditos
                                            </Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                    <Tab.Content className="tab-content-custom">
                                        <Tab.Pane eventKey="agradecimientos">
                                            <div className="acknowledgements-content">
                                                {renderAcknowledgements()}
                                            </div>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="creditos">
                                            <div className="credits-content">
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="editorial-credits">
                                                            {renderCredits()}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="production-credits">
                                                            {renderProductionCredits()}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Tab.Pane>
                                    </Tab.Content>
                                </Tab.Container>
                            </div>
                        </Col>
                    </div>
                </div>


                <Footer />
            </div>

            {/* Modal de Video */}
            <Modal
                show={showModal}
                onHide={handleCloseModal}
                size="lg"
                centered
                className="modal-series"
            >
                <Modal.Header closeButton className="modal-series-header">
                    <Modal.Title className="modal-series-title">
                        {selectedChapter?.title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="modal-series-body">
                    {selectedChapter && (
                        <>
                            <div className="modal-series-video-container">
                                <iframe
                                    src={selectedChapter.url_capitulo}
                                    width="100%"
                                    height="100%"
                                    frameBorder="0"
                                    allow="autoplay; fullscreen; picture-in-picture"
                                    allowFullScreen
                                    title={selectedChapter.title}>
                                </iframe>
                            </div>
                            <div className="modal-series-info">
                                <p className="modal-series-author">
                                    <strong>Autor:</strong> {selectedChapter.autor}
                                </p>
                                <p className="modal-series-duration">
                                    <strong>Duración:</strong> {selectedChapter.duracion}
                                </p>
                                {selectedChapter.doi && (
                                    <p className="modal-series-doi">
                                        <strong>DOI:</strong> <a href={selectedChapter.doi} target="_blank" rel="noopener noreferrer">{selectedChapter.doi}</a>
                                    </p>
                                )}
                            </div>
                        </>
                    )}
                </Modal.Body>
                {/* <Modal.Footer className="modal-series-footer">
                    <button className="modal-series-btn-secondary" onClick={handleCloseModal}>
                        Cerrar
                    </button>
                    <button className="modal-series-btn-primary" onClick={handleViewFullChapter}>
                        Ver capítulo completo
                    </button>
                </Modal.Footer> */}
            </Modal>
        </>
    );
}

export default Series;